import Vue from 'vue';

import App from './App';
import router from './router';
import i18n from './assets/languages/i18n';
import vuetify from './plugins/vuetify';

new Vue({
  i18n,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
